var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5C1 15.3438 1.65625 16 2.5 16H11.5C12.3125 16 13 15.3438 13 14.5V4H1V14.5ZM9.5 6.5C9.5 6.25 9.71875 6 10 6C10.25 6 10.5 6.25 10.5 6.5V13.5C10.5 13.7812 10.25 14 10 14C9.71875 14 9.5 13.7812 9.5 13.5V6.5ZM6.5 6.5C6.5 6.25 6.71875 6 7 6C7.25 6 7.5 6.25 7.5 6.5V13.5C7.5 13.7812 7.25 14 7 14C6.71875 14 6.5 13.7812 6.5 13.5V6.5ZM3.5 6.5C3.5 6.25 3.71875 6 4 6C4.25 6 4.5 6.25 4.5 6.5V13.5C4.5 13.7812 4.25 14 4 14C3.71875 14 3.5 13.7812 3.5 13.5V6.5ZM13.5 1H9.75L9.4375 0.4375C9.3125 0.1875 9.03125 0 8.78125 0H5.1875C4.9375 0 4.625 0.1875 4.53125 0.4375L4.25 1H0.5C0.21875 1 0 1.25 0 1.5V2.5C0 2.78125 0.21875 3 0.5 3H13.5C13.75 3 14 2.78125 14 2.5V1.5C14 1.25 13.75 1 13.5 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.796b83e3bc2f839cdc221ab201ea36e1.svg";
export { ForwardRef as ReactComponent };